import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-turns-new-location-dashboard',
  templateUrl: './turns-new-location-dashboard.component.html',
  styleUrls: ['./turns-new-location-dashboard.component.scss']
})
export class TurnsNewLocationDashboardComponent implements OnInit {

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-map-marker-alt', 'turns-page.new location', '/turns/parameters/locations', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.parameters', '/turns/parameters'), new BRoute('turns-page.locations', '/turns/parameters/locations'), new BRoute('turns-page.new location')]));
  }

}
